



































































import {
  Component,
  Vue,
  Prop,
  ComponentStyle,
  ComponentStyleDefinition,
  VueComponent,
  QuestionType,
  InjectComponent,
  Question,
  Watch,
  FilterPanelSettings,
  FilterQuestionSettings,
  ChoiceQuestion,
  Answer,
  QuestionTypeChecker,
} from "@zoovu/runner-browser-api";

import { FiltersSettings } from "@zoovu/runner-web-design-base/src/components/types";
import {
  FilterQuestionView,
  FilterCheckboxAnswerView,
  FilterRadioButtonAnswerView,
} from "@zoovu/runner-web-design-base";
import { sanitize } from "dompurify";
import { isMobile, isTablet } from "@zoovu/design-system/src/helpers/index";
import Vuebar from "vuebar";
import TooltipService from "../services/tooltip-service";
import { IconChevron } from "./svgs";
import { whitelistedAttributes } from "../types";

Vue.use(Vuebar);

@Component({ components: { IconChevron }, name: "FilterQuestionView", mixins: [FilterQuestionView] })
export default class FilterQuestionViewExtended extends Vue {
  @InjectComponent("FilterCheckboxAnswerView")
  filterCheckboxAnswer!: VueComponent;

  @InjectComponent("FilterRadioButtonAnswerView")
  filterRadioButtonAnswer!: VueComponent;

  @InjectComponent("SliderQuestionView")
  sliderQuestion!: VueComponent;

  @InjectComponent("RangeQuestionView")
  rangeQuestion!: VueComponent;

  @InjectComponent("FilterDropDownQuestionView")
  filterDropDownQuestion!: VueComponent;

  @InjectComponent("Modal")
  modal: VueComponent;

  @ComponentStyle()
  componentStyle!: ComponentStyleDefinition;

  @Prop()
  private question!: Question;

  @Prop()
  public readonly panelSettings!: FilterPanelSettings;

  @Prop()
  private initiallyExpanded!: boolean;

  isMobile: boolean = isMobile();

  isTablet: boolean = isTablet();

  isExpanded = Boolean(this.initiallyExpanded);

  infoTextShown = false;

  showAllAnswers = false;

  questionType = QuestionType;

  get questionSettings(): FilterQuestionSettings {
    return this.question.parameters ? this.question.parameters : {};
  }

  get answersLimitingEnabled(): boolean {
    return typeof this.questionSettings[FiltersSettings.LIMIT_SHOWN_ANSWERS] === "number";
  }

  get showMoreButtonShouldBeShown(): boolean {
    return (
      QuestionTypeChecker.isChoiceQuestion(this.question) &&
      this.answersLimitingEnabled &&
      this.questionSettings[FiltersSettings.LIMIT_SHOWN_ANSWERS] < (this.question as ChoiceQuestion).answers.length
    );
  }

  get toggleShowAllAnswersText(): string {
    return this.showAllAnswers ? "message-filter-less" : "message-filter-more";
  }

  get choiceAnswersToDisplay(): Array<Answer> {
    const choiceQuestion = this.question as ChoiceQuestion;
    return choiceQuestion.answers.slice(
      0,
      this.answersLimitingEnabled && !this.showAllAnswers
        ? this.questionSettings[FiltersSettings.LIMIT_SHOWN_ANSWERS]
        : choiceQuestion.answers.length
    );
  }

  get isGrayedOutAnswersEnabled(): boolean {
    if (typeof this.questionSettings[FiltersSettings.SHOW_DISABLED_AS_GREYED_OUT] === "boolean") {
      return this.questionSettings[FiltersSettings.SHOW_DISABLED_AS_GREYED_OUT];
    }

    return this.panelSettings ? !!this.panelSettings[FiltersSettings.SHOW_DISABLED_AS_GREYED_OUT] : false;
  }

  get isHideOptionLabelsEnabled(): boolean {
    if (typeof this.questionSettings[FiltersSettings.HIDE_OPTION_LABELS] === "boolean") {
      return this.questionSettings[FiltersSettings.HIDE_OPTION_LABELS];
    }

    return this.panelSettings ? !!this.panelSettings[FiltersSettings.HIDE_OPTION_LABELS] : false;
  }

  @Watch("initiallyExpanded")
  updateExpanded(): void {
    this.isExpanded = this.initiallyExpanded;
  }

  mounted(): void {
    if (this.question.infoText && !this.isMobile && !this.isTablet) {
      TooltipService.createTooltip(`#${this.question.mid} p > .info-text-trigger`, {
        content: sanitize(this.question.infoText, { ADD_ATTR: whitelistedAttributes }),
        trigger: "mouseenter",
        placement: "top",
        distance: 10,
      });
    }
  }

  showInfoText(): void {
    this.infoTextShown = true;
  }

  hideInfoText(): void {
    this.infoTextShown = false;
  }

  toggleShowAllAnswers(): void {
    this.showAllAnswers = !this.showAllAnswers;
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  clickOnInfoText(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isMobile && !this.isTablet) return;
    this.showInfoText();
  }

  triggerClass(): string {
    return `info-text-trigger info-text-trigger-${this.question.id}`;
  }

  getComponentByQuestionType(questionType: QuestionType): Vue {
    return questionType === QuestionType.CHECKBOX
      ? (this.filterCheckboxAnswer as FilterCheckboxAnswerView)
      : (this.filterRadioButtonAnswer as FilterRadioButtonAnswerView);
  }
}
